import rill from "rill";
import Competitions from "./competitions";

const CompetitionsController = (app) => {
  app.at("/competitions/*", rill().setup(Competitions));
};

export default CompetitionsController;
